import { createFileRoute } from "@tanstack/react-router";

import { api } from "~/lib/api";

export const Route = createFileRoute(
  "/_main/settings/_layout/devices/payment-terminals",
)({
  component: PaymentTerminals,
});

function PaymentTerminals() {
  const { data } = api.terminal.listTerminals.useQuery();
  return <div></div>;
}
